import React, {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPhone} from '@fortawesome/free-solid-svg-icons';
import { faPerson, faPersonDress, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';

function Hostel_booking({setHostelbooking}) {
    const [name, setName] = useState('')
    const [schoolname, setSchoolname] = useState('')
    const [schoollocation, setSchoollocation] = useState('')
    const [phone, setPhone] = useState('')
    const [altphone, setAltphone] = useState('')
    const [date, setDate] = useState('')

    const [check, setCheck] = useState(false)
    const [book, setBook] = useState('')
    const [loading, setLoading] = useState(false)

    const premium = () =>{
         setBook('premium')
         setCheck(true)
    }

    const standard = () =>{
        setBook('Book Standard')
        setCheck(true)
    }

    const checks = () =>{
        setBook('')
        setCheck(false)
    }


    const scroll = () =>{

        if (name==''||schoolname==''||schoollocation==''||phone==''||altphone==''||check==false||date=='') {
            
            if(name=='')alert('please add your name')
            if(schoolname=='') alert('please add your school name')
            if(altphone=='') alert('please add your school alternative phone number')
            if(schoollocation=='') alert('please add your school location')
            if(phone=='') alert('please add your phone number')
            if(check==false) alert('please select your booking standard')
            if(date=='') alert('please add expected reporting date')

        } else {
                 setLoading(true)
                 fetch('https://hosteladventures.site/PHP/Booking/hostel_booking.php', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                       name,
                       schoolname,
                       altphone,
                       schoollocation,
                       phone,
                       book,
                       date
                    })
                  })
                    .then(response => response.json())
                    .then(data => {
                      // Handle response from backend (e.g., login success or failure)
                      if(data.message=='in')
                      {
                        setLoading(false)
                        alert('Thank you for booking with us, we will contact you within the next 24 hours')
                        setHostelbooking(false)
                      }
      
                     
                   
                    })
                    .catch(error => {
                      console.error('Error:', error);
                      alert('Error Uploading,!! Check Internet Connection')
                      setLoading(false)
                    });
        }

    }
   
  return (
        <div className='Form_HBK'>
            <p className='fill_In'>Hostel Booking</p>
            <input placeholder='Student Name' onChange={(event) => setName(event.target.value)} />
            <input placeholder='School/institution name' onChange={(event) => setSchoolname(event.target.value)} />
            <input placeholder='School or intitutuion Location' onChange={(event) => setSchoollocation(event.target.value)} />
            <div>
                <p className='Book_STD'>Click One</p>
                {!check?( <div className='Book_STD_BTNS'>
                   <div onClick={standard} className='Book_std_inner_BTN'>Book Standard</div>
                   <div onClick={premium} className='Book_std_inner_BTN'>Book Premium</div>
                </div>):(<div><button onClick={checks}><FontAwesomeIcon icon={faCheck} /></button></div>)}
               
            </div>
            <input placeholder='Phone Number' onChange={(event) => setPhone(event.target.value)}/>
            <input placeholder='Aternative Phone Number' onChange={(event) => setAltphone(event.target.value)} />
            <div>
                <div className='DOM_PH'>Expected Reporting Date:</div>
                  <input type='date' placeholder='date of admission' onChange={(event) => setDate(event.target.value)} />
                </div>
           
           {!loading?(<div className='submit' onClick={scroll}>Submit</div>):(<div className='submit'>Loading...</div>)}
            
            
        </div>
  )
}

export default Hostel_booking